import React from 'react';
import {Link} from 'react-router-dom';


function Footer(props) {

    return (
        <>
            <footer id="contact">
                <div className="wrap flex flex-col h-full">
                    <div className="top flex border-b border-neutral-700">
                        <article className="w-1/2 relative after:content-[''] after:w-px after:bg-neutral-700 after:absolute after:end-0 pb-8">
                            <h3 className="text-5xl pb-4">EMAIL</h3>
                            <Link to="mailto:mypiay123@gmail.com" className="font-extralight">mypiay123@gmail.com</Link>
                        </article>
                        <article className="w-1/2 pl-8 pb-8">
                            <h3 className="text-5xl pb-4">PHONE</h3>
                            <Link to="tel:010-6425-5349" className="font-extralight">010-6425-5349</Link>
                        </article>
                    </div>
                    <div style={props.bg} className="relative bg-clip-text text-center mt-auto">
                        THANK YOU
                        <p className="absolute text-sm w-full text-white/80 font-extralight leading-none">
                            본 페이지는 1920*1080 해상도에 최적화되어있습니다 <span className="px-1">|</span> 
                            페이지에 포함된 이미지는 따로 출처가 있습니다
                        </p>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;